import { render, staticRenderFns } from "./recycleCopywriting.vue?vue&type=template&id=7571ee43&scoped=true&"
import script from "./recycleCopywriting.vue?vue&type=script&lang=js&"
export * from "./recycleCopywriting.vue?vue&type=script&lang=js&"
import style0 from "./recycleCopywriting.vue?vue&type=style&index=0&id=7571ee43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7571ee43",
  null
  
)

export default component.exports